import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, XCircle, X } from 'lucide-react';

// Feature flag to globally disable local notifications
const NOTIFICATIONS_ENABLED = false;

const LocalNotification = ({ 
  message, 
  type = 'success', 
  isVisible, 
  onClose, 
  position = 'bottom' 
}) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  // Render nothing when disabled or not visible
  if (!NOTIFICATIONS_ENABLED || !isVisible) return null;

  // If visible and enabled, proceed to render

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle className="h-4 w-4 text-green-500" />;
      case 'error':
        return <XCircle className="h-4 w-4 text-red-500" />;
      default:
        return <CheckCircle className="h-4 w-4 text-blue-500" />;
    }
  };

  const getBackgroundColor = () => {
    switch (type) {
      case 'success':
        return 'bg-green-900/90 border-green-500/50';
      case 'error':
        return 'bg-red-900/90 border-red-500/50';
      default:
        return 'bg-blue-900/90 border-blue-500/50';
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 10, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -10, scale: 0.95 }}
        transition={{ duration: 0.2 }}
        className={`absolute z-50 ${position === 'bottom' ? 'top-full mt-2' : 'bottom-full mb-2'} left-1/2 transform -translate-x-1/2`}
      >
        <div className={`${getBackgroundColor()} backdrop-blur-sm border rounded-lg px-3 py-2 shadow-lg min-w-[200px] max-w-[300px]`}>
          <div className="flex items-center space-x-2">
            {getIcon()}
            <span className="text-white text-sm font-medium flex-1">
              {message}
            </span>
            <button
              onClick={onClose}
              className="text-gray-300 hover:text-white transition-colors"
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        </div>
        
        {/* Arrow pointing to button */}
        <div className={`absolute left-1/2 transform -translate-x-1/2 ${
          position === 'bottom' ? 'top-0 -mt-1' : 'bottom-0 -mb-1'
        }`}>
          <div className={`w-2 h-2 bg-gray-800 transform rotate-45 ${
            position === 'bottom' ? 'border-t border-l' : 'border-b border-r'
          } border-gray-600`}></div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default LocalNotification;
